import { useEffect, useState } from "react";
import { fetchDefaultRewardPointsAPI, fetchRewardOpenAPI } from "./rewardAPI";

// 출제 창의 '완료 포인트'. 지인에듀 문제지 출제와 문제뱅크 출제가 함께 쓴다.
// 처음 열 때 이 학원·유형의 마지막 값(처음은 100)을 서버에서 받아 채운다.
// 값을 비워 보내도 서버가 같은 기본값을 넣으므로 포인트가 빠지는 출제는 없다.
export const useDefaultRewardPoints = (assignmentType, setRewardPoints) => {
  useEffect(() => {
    if (!assignmentType) return undefined;
    let isCurrent = true;
    fetchDefaultRewardPointsAPI(assignmentType)
      .then((points) => {
        if (isCurrent) setRewardPoints(points);
      })
      .catch(() => {});
    return () => {
      isCurrent = false;
    };
  }, [assignmentType, setRewardPoints]);
};

// 상점을 켜지 않은 학원(기프티쇼 키 + 활성화 체크 전)에는 칸을 띄우지 않는다. 서버도 그런 학원에는 포인트를 쌓지 않는다.
const RewardPointsField = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    fetchRewardOpenAPI().then((open) => isCurrent && setIsOpen(open));
    return () => {
      isCurrent = false;
    };
  }, []);
  if (!isOpen) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "14px",
        padding: "13px 16px",
        backgroundColor: "#F4F8F7",
        borderRadius: "13px",
      }}
    >
      <div
        style={{
          flex: 1,
          fontSize: "0.86rem",
          fontWeight: 800,
          color: "#0E141B",
          letterSpacing: "-0.01em",
        }}
      >
        완료 포인트
      </div>
      <input
        type="number"
        min={0}
        step={10}
        inputMode="numeric"
        value={value ?? ""}
        onChange={(event) =>
          onChange(
            event.target.value === ""
              ? ""
              : Math.max(0, Number(event.target.value)),
          )
        }
        style={{
          width: "90px",
          padding: "7px 10px",
          border: "1.5px solid #D6DEE0",
          borderRadius: "9px",
          fontSize: "0.95rem",
          fontWeight: 800,
          textAlign: "right",
        }}
      />
      <span style={{ fontWeight: 800, color: "#0E141B" }}>P</span>
    </div>
  );
};

export default RewardPointsField;
